import { useMemo, FunctionComponent, SVGProps } from 'react'
import classNames from 'classnames'

import styles from './icon-shape.module.scss'

export type IconShapeVariants = 'brand' | 'warning' | 'neutral' | 'white' | 'on-brand'

export type IconSizeVariants = 'large' | 'medium' | 'small' | 'x-small' | 'xx-small'

export interface IconShapeProps {
  className?: string
  iconClassName?: string
  variant?: IconShapeVariants
  size?: IconSizeVariants
  icon: FunctionComponent<SVGProps<SVGSVGElement>> | React.ElementType
}

export const IconShape = ({
  className = '',
  iconClassName,
  variant = 'neutral',
  size = 'large',
  icon,
}: IconShapeProps) => {
  const renderIcon = useMemo(() => {
    const Icon = icon as React.ElementType
    return <Icon className={classNames(styles['icon'], iconClassName)} />
  }, [icon, iconClassName])

  return (
    <div className={classNames(styles['icon-shape'], styles[size], styles[variant], className)}>
      {renderIcon}
    </div>
  )
}

export default IconShape
